import axios from 'axios';

export function getScreenHostOnboarding(token) {
    return axios.get(`${process.env.REACT_APP_API_URL}/screenHost/onboarding`, {
        headers: { Authorization: token },
    });
}

export function patchScreenHostOnboarding(token, body) {
    return axios.patch(`${process.env.REACT_APP_API_URL}/screenHost/onboarding`, body, {
        headers: { Authorization: token },
    });
}
